export default __webpack_public_path__ + "static/media/newWallat.0ab8e069.svg";